/* eslint-disable no-console */

import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-image-lightbox/style.css';
import { Provider } from 'react-redux';
import { SettingsProvider } from './contexts/SettingsContext';
import NotistackProvider from './providers/NotistackProvider';
import reportWebVitals from './reportWebVitals';
import App from './scaffold/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { store } from './store';
import './styles/bootstrap.css';
import './styles/index.css';
import ThemeProvider from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <SettingsProvider>
                <ThemeProvider>
                    <NotistackProvider>
                        <App />
                    </NotistackProvider>
                </ThemeProvider>
            </SettingsProvider>
        </Provider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        alert('New version of myKanisa available!  Ready to  auto update?');
        if (registration && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        window.location.reload();
    },
});

// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
